import createReactClass from 'create-react-class';
/* eslint-disable react/prop-types */
// -*- mode: jsx;-*-
import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';

import { makeSchoolURL } from '../common/searchRequestUtils.js';
import { AjaxLink } from '../common/ajaxLink.js';
import { SchoolGiveButtons } from './SchoolGiveButtons.js';
import { buildHackySchoolPageUrl } from '../common/buildHackySchoolPageUrl.js';

const School = createReactClass({
    mixins: [PureRenderMixin],

    render: function () {
        const props = this.props;
        const schoolLink = makeSchoolURL(props.baseSearchURL, props.schoolId);

        return (
            <div className="school">
                <div className="school-search-title">
                    <div className="school-marker-icon"></div>
                    <a className="school-background-link" href={buildHackySchoolPageUrl(props.schoolId)}>
                        <div className="school-name">{props.schoolName}</div>
                        <div className="secondary-info">{props.cityName}, {props.stateCode}</div>
                    </a>
                </div>
                <SchoolGiveButtons schoolId={props.schoolId} />
            </div>
        );
    },
});

export default School;
